export interface RegistrationRequestInput {
  fullName: string;
  email: string;
  institutionName: string;
  institutionCnpj: string;
  institutionCity: string;
}

export interface RegistrationRequestPayload {
  full_name: string;
  email: string;
  institution_name: string;
  institution_cnpj: string;
  institution_city: string;
}

export type RegistrationRequestStatus = "PENDING" | "APPROVED" | "REJECTED";

export interface RegistrationRequestResponse
  extends RegistrationRequestPayload {
  id: number;
  status: RegistrationRequestStatus;
  created_at: string;
  updated_at: string;
}

export interface AdminRegistrationRequestResponse
  extends RegistrationRequestResponse {
  reviewed_by_keycloak_id?: string | null;
  reviewed_by_email?: string | null;
  reviewed_by_name?: string | null;
  reviewed_at?: string | null;
  rejection_reason?: string | null;
  created_keycloak_user_id?: string | null;
  email_sent_at?: string | null;
  email_error?: string | null;
}

export interface AdminRegistrationRequestListResponse {
  items: AdminRegistrationRequestResponse[];
  total: number;
  offset: number;
  limit: number;
}

export type AdminRegistrationRequestStatusFilter =
  | RegistrationRequestStatus
  | "ALL";

export interface AdminRegistrationRequestListParams {
  status?: RegistrationRequestStatus;
  offset?: number;
  limit?: number;
}

export interface FastApiValidationDetail {
  loc: Array<string | number>;
  msg: string;
  type: string;
}

export interface FastApiErrorResponse {
  detail?: string | FastApiValidationDetail[];
}

export type RegistrationRequestErrorCode =
  | "CONFLICT"
  | "VALIDATION"
  | "UNAVAILABLE"
  | "NETWORK"
  | "UNKNOWN";

export class RegistrationRequestServiceError extends Error {
  constructor(
    public readonly code: RegistrationRequestErrorCode,
    message: string,
    public readonly status?: number,
    public readonly validationDetails: FastApiValidationDetail[] = []
  ) {
    super(message);
    this.name = "RegistrationRequestServiceError";
  }
}
